/**
 * SSO Configuration for Kit19 Sales CRM
 * 
 * This configuration integrates Kit19 SSO authentication
 * with the Sales CRM Platform
 */

const getSSOConfig = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';
  
  // Get the current origin for callback URLs
  const appOrigin = window.location.origin;
  
  return {
    // SSO Server Configuration
    ssoLoginUrl: process.env.REACT_APP_SSO_LOGIN_URL || 'https://sso.kit19.com/login',
    ssoLogoutUrl: process.env.REACT_APP_SSO_LOGOUT_URL || 'https://sso.kit19.com/logout',
    ssoApiUrl: process.env.REACT_APP_SSO_API_URL || 'https://auth.kit19.com/api/',
    
    // Application Configuration
    appName: 'Kit19 Sales CRM',
    appId: 'kit19-sales',
    
    // Callback Configuration
    callbackUrl: `${appOrigin}/callback`,
    logoutUrl: `${appOrigin}/logout`,
    errorUrl: `${appOrigin}/login?error=true`,
    
    // Token Configuration
    tokenStorageKey: 'kit_token',          // Primary token key
    userStorageKey: 'kit_user',            // User info storage key
    refreshTokenKey: 'kit_refresh_token',  // Refresh token key

    // Session Configuration
    tokenRefreshInterval: 5 * 60 * 1000, // 5 minutes
    sessionTimeout: 30 * 60 * 1000, // 30 minutes of inactivity
    
    // Security Configuration
    enableMultiTabSync: true,
    enableAutoLogout: true,
    requireSecureConnection: !isDevelopment,
    
    // Features
    enableSocialLogin: true,
    enableMFA: true,
    enableAutoRefresh: true,
    
    // OAuth2 Scopes (if using OAuth)
    scopes: [
      'openid',
      'profile',
      'email',
      'phone'
    ],
    
    // Claims to request from SSO
    userInfoClaims: {
      userId: 'sub',
      email: 'email',
      name: 'name',
      phone: 'phone_number',
      picture: 'picture',
      emailVerified: 'email_verified',
      phoneVerified: 'phone_number_verified'
    },
    
    // Redirect behavior
    redirectOnLogin: '/',
    redirectOnLogout: '/login',
    preserveReturnUrl: true,
    
    // Logging
    debug: isDevelopment,
    enableConsoleLogging: isDevelopment,
    
    // API Endpoints
    endpoints: {
      authenticate: '/auth/authenticate',
      validateToken: '/auth/validate',
      refreshToken: '/auth/refresh',
      logout: '/auth/logout',
      userInfo: '/user/info',
      userProfile: '/user/profile'
    }
  };
};

// Export as singleton
let config = null;

export const initSSOConfig = () => {
  if (!config) {
    config = getSSOConfig();
  }
  return config;
};

export const getSSOConfigInstance = () => {
  if (!config) {
    config = getSSOConfig();
  }
  return config;
};

// Default export for immediate use
export default getSSOConfig();
